import { render, staticRenderFns } from "./invitationList.vue?vue&type=template&id=7e24c1e1&scoped=true&"
import script from "./invitationList.vue?vue&type=script&lang=js&"
export * from "./invitationList.vue?vue&type=script&lang=js&"
import style0 from "./invitationList.vue?vue&type=style&index=0&id=7e24c1e1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e24c1e1",
  null
  
)

export default component.exports